import { gql } from "@apollo/client";
import client from "@services/apolloClient";

/** Model Details Variants **/
export const FIND_MODEL_DETAILS_VARIANTS = gql`
  query FindModelDetails($slug: String!, $cityName: String!) {
    findModelDetails(slug: $slug, cityName: $cityName) {
      allVariantSlugs {
        uniqueSortedVariants {
          variantName
          fuelType
          engine
          emission
          transmission
          slug
          marketPrice
          adspPrice
          ackoDriveSavings
          exShowRoomPrice
          onRoadPrice
          featureItemDtos {
            name
            description
            value
          }
          mileage {
            value
            unit
          }
          variantLevel
          expressDelivery
          expressDeliveryDays
          standardDeliveryDays
          status
        }
        topVariant {
          variantName
          fuelType
          engine
          emission
          transmission
          slug
          marketPrice
          adspPrice
          ackoDriveSavings
          exShowRoomPrice
          onRoadPrice
          variantLevel
        }
        baseVariant {
          variantName
          fuelType
          engine
          emission
          transmission
          slug
          marketPrice
          adspPrice
          ackoDriveSavings
          exShowRoomPrice
          onRoadPrice
          variantLevel
        }
        topSellingVariant {
          variantName
          fuelType
          engine
          emission
          transmission
          slug
          marketPrice
          adspPrice
          ackoDriveSavings
          exShowRoomPrice
          onRoadPrice
          variantLevel
        }
        midVariant {
          variantName
          fuelType
          engine
          emission
          transmission
          slug
          marketPrice
          adspPrice
          ackoDriveSavings
          exShowRoomPrice
          onRoadPrice
          variantLevel
        }
        allVariantsCount
      }
      fuelTypes
      transmissionTypes
      minPrice
      maxPrice
      modelExpressDeliveryFlag
      modelMinDeliveryDays
      status
      brand {
        name
      }
      model {
        name
      }
    }
  }
`;

export async function fetchModelDetailsVariants(
  slug: string,
  cityName: string
) {
  try {
    const { data } = await client.query({
      query: FIND_MODEL_DETAILS_VARIANTS,
      variables: { slug, cityName },
    });

    return data?.findModelDetails || [];
  } catch (error: any) {
    console.error("Error fetching model details variants:", error?.message);
    return [];
  }
}
